// src/components/Issues/IssueRow.js
import React from 'react';
import {
  TableRow,
  TableCell,
  Typography,
  Chip,
  IconButton,
  Box,
} from '@mui/material';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import { getStatusColor } from './utils';

const IssueRow = ({
  issue,
  onOpenMenu,
  processingId,
}) => {
  const handleOpenMenu = (event) => {
    onOpenMenu(event, issue);
  };



  return (
    <TableRow hover>
      <TableCell>
        <Typography variant="body2" fontWeight={500}>
          {issue?.lead?.name}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{issue.title}</Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">
          {issue.last_issue_log?.author?.name || 'N/A'}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">
          {issue.created_at || 'N/A'}
        </Typography>
      </TableCell>
      <TableCell>
        <Chip
          label={issue.last_issue_log?.status?.name || 'Pending'}
          color={getStatusColor(issue.last_issue_log?.status?.name)}
          size="small"
        />
      </TableCell>
      <TableCell align="center">
        <IconButton
          size="small"
          onClick={handleOpenMenu}
          disabled={processingId === issue.id}
        >
          <MoreVertIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export default IssueRow;